import { FC } from 'react'
import {
  Typography,
  ListItem,
  ListItemButton,
  ListItemText,
  TypographyProps,
  ListItemIcon,
  CircularProgress,
  SvgIconProps,
} from '@mui/material'
import { nothing } from '$helper/functions/utils'

interface Props {
  // TODO make required
  onClick?: () => unknown
  text: string
  typographyProps?: TypographyProps
  loading?: boolean
  Icon?: FC<SvgIconProps>
}

export function ListItemCriticalTextButton({
  text,
  Icon,
  onClick = nothing,
  typographyProps = {
    variant: 'subtitle3',
    color: 'error500',
  },
  loading,
}: Props) {
  const { variant, color } = typographyProps
  return (
    <ListItem disablePadding sx={{ bgcolor: 'white' }}>
      <ListItemButton disabled={loading} onClick={onClick}>
        {Icon && (
          <ListItemIcon sx={{ minWidth: 0, paddingLeft: '8px' }}>
            <Icon sx={{ width: '24px', height: '24px', color: 'error500' }} />
          </ListItemIcon>
        )}
        <ListItemText
          primary={
            <Typography variant={variant} color={color}>
              {text}
            </Typography>
          }
        />
        {loading && (
          <ListItemIcon>
            <CircularProgress size={22} color="error" />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  )
}
